import { AppLayout } from "@bcc/components/app-layout";
import { OrdersView } from "@bcc/components/views/orders-view";

interface OrderData {
  id: string;
  customer: string;
  product: string;
  quantity: number;
  weight: number;
  amount: string;
  status: "completed" | "waiting" | "shipped" | "cancelled";
  date: string;
  age: string;
  marketplace: string;
  tracking: string | null;
  batch: string | null;
  carrier: "USPS" | "UPS";
}

interface BatchData {
  id: string;
  createdAt: string;
  status: "completed" | "inProgress" | "error";
  orders: number;
  carrier: string;
  weight: number;
  manifestGenerated: boolean;
}

const ordersData: OrderData[] = [
  {
    id: "ORD-001",
    customer: "John Doe",
    product: "Ethiopia Yirgacheffe",
    quantity: 2,
    weight: 1.5,
    amount: "$44.00",
    status: "completed",
    date: "2024-12-01",
    age: "3 days",
    marketplace: "Shopify",
    tracking: "1Z999AA10123456784",
    batch: "BATCH-001",
    carrier: "USPS",
  },
  {
    id: "ORD-002",
    customer: "Jane Smith",
    product: "Colombia Supremo",
    quantity: 1,
    weight: 0.75,
    amount: "$18.00",
    status: "shipped",
    date: "2024-12-02",
    age: "2 days",
    marketplace: "Shopify",
    tracking: "1Z999AA10123456785",
    batch: "BATCH-001",
    carrier: "UPS",
  },
  {
    id: "ORD-003",
    customer: "Bob Johnson",
    product: "Italo Disco Italian",
    quantity: 3,
    weight: 2.25,
    amount: "$60.00",
    status: "waiting",
    date: "2024-12-03",
    age: "1 day",
    marketplace: "Shopify",
    tracking: null,
    batch: null,
    carrier: "USPS",
  },
  {
    id: "ORD-004",
    customer: "Alice Williams",
    product: "Wide Awake Dark",
    quantity: 5,
    weight: 3.75,
    amount: "$94.95",
    status: "completed",
    date: "2024-12-04",
    age: "0 days",
    marketplace: "Shopify",
    tracking: "1Z999AA10123456786",
    batch: "BATCH-002",
    carrier: "UPS",
  },
  {
    id: "ORD-005",
    customer: "Carol Davis",
    product: "El Zapote",
    quantity: 2,
    weight: 1.5,
    amount: "$43.00",
    status: "shipped",
    date: "2024-12-03",
    age: "1 day",
    marketplace: "Manual",
    tracking: "1Z999AA10123456787",
    batch: "BATCH-002",
    carrier: "USPS",
  },
  {
    id: "ORD-006",
    customer: "David Miller",
    product: "Orthodox House",
    quantity: 1,
    weight: 0.5,
    amount: "$24.00",
    status: "waiting",
    date: "2024-12-04",
    age: "0 days",
    marketplace: "Manual",
    tracking: null,
    batch: null,
    carrier: "UPS",
  },
  {
    id: "ORD-007",
    customer: "Emily Brown",
    product: "Ethiopia Yirgacheffe",
    quantity: 4,
    weight: 3.0,
    amount: "$88.00",
    status: "cancelled",
    date: "2024-12-02",
    age: "2 days",
    marketplace: "Shopify",
    tracking: null,
    batch: null,
    carrier: "USPS",
  },
  {
    id: "ORD-008",
    customer: "Frank Wilson",
    product: "Colombia Supremo",
    quantity: 2,
    weight: 1.5,
    amount: "$36.00",
    status: "completed",
    date: "2024-12-01",
    age: "3 days",
    marketplace: "Shopify",
    tracking: "1Z999AA10123456788",
    batch: "BATCH-001",
    carrier: "USPS",
  },
];

const batchesData: BatchData[] = [
  {
    id: "BATCH-001",
    createdAt: "2024-12-01",
    status: "completed",
    orders: 15,
    carrier: "USPS",
    weight: 11.25,
    manifestGenerated: true,
  },
  {
    id: "BATCH-002",
    createdAt: "2024-12-03",
    status: "inProgress",
    orders: 8,
    carrier: "UPS",
    weight: 6.0,
    manifestGenerated: false,
  },
  {
    id: "BATCH-003",
    createdAt: "2024-12-02",
    status: "completed",
    orders: 22,
    carrier: "USPS",
    weight: 16.5,
    manifestGenerated: true,
  },
  {
    id: "BATCH-004",
    createdAt: "2024-12-04",
    status: "error",
    orders: 5,
    carrier: "UPS",
    weight: 3.75,
    manifestGenerated: false,
  },
];

export function OrdersPage() {
  return (
    <AppLayout>
      <OrdersView ordersData={ordersData} batchesData={batchesData} />
    </AppLayout>
  );
}
